<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader />
  
      <!-- Customization Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>Edit Product Customization</h2>
            <form @submit.prevent="handleSubmit">
              <!-- Price Inputs -->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="extraPrice">Extra Price</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="extraPrice" 
                    v-model="form.extraPrice" 
                    required
                  >
                </div>
              </div>
  
              <!-- Cost and ERP -->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="cost">Cost</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="cost" 
                    v-model="form.cost" 
                    required
                  >
                </div>
                <div class="form-group col-md-6">
                  <label for="erpItem">ERP Item Code</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="erpItem" 
                    v-model="form.ERP_Item" 
                  >
                </div>
              </div>
  
              <!-- Defaults Toggle -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input 
                      type="checkbox" 
                      class="form-check-input" 
                      id="defaults" 
                      v-model="form.defaults"
                    >
                    <label class="form-check-label" for="defaults">
                      Set as Default Customization
                    </label>
                  </div>
                </div>
              </div>
  
              <!-- Name Translations -->
              <div class="form-row" v-for="(lang) in languages" :key="lang.id">
                <div class="form-group col-md-12">
                  <label :for="'name_' + lang.id">Name ({{ lang.fullName }})</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    :id="'name_' + lang.id" 
                    v-model="findNameForLanguage(lang.id).name" 
                    required
                  >
                </div>
              </div>
  
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="cancelForm">Cancel</button>
                  <button type="submit" class="btn btn-primary">Update Customization</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
        id: null,
        itemId: null,
        extraPrice: '',
        defaults: false,
        cost: '',
        price: 0,
        ERP_Item: '',
        names: []
      },
      languages: [],
      currentDate: '',
      currentTime: '',
      loading: true
      };
    },
    mounted() {
      this.loadCustomization();
      this.loadLanguages();
      this.updateDateTime();
      setInterval(this.updateDateTime, 1000);
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      async loadCustomization() {
      try {
        this.$root.isLoading = true; 
          this.loading = true;
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${this.$BASE_API_URL}/api/customizations/${this.$route.params.id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch customization');
        }

        const { data } = await response.json();
        
        this.form = {
          id: data.id,
          itemId: data.itemId,
          extraPrice: data.extraPrice,
          defaults: data.defaults === 1, 
          cost: data.cost,
          price: data.price,
          ERP_Item: data.ERP_Item,
          names: data.languages.map(lang => ({
            langId: lang.langId,
            name: lang.name
          }))
        };

        this.loading = false;
      } catch (error) {
        console.error('Error loading customization:', error);
        this.$toast.error('Failed to load customization data');
        this.$router.go(-1);
      }
      finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
    },
      loadLanguages() {
        const storedLangs = localStorage.getItem('languages');
        if (storedLangs) {
          this.languages = JSON.parse(storedLangs);
        }
      },
      findNameForLanguage(langId) {
        // Find existing name for this language or create a new one
        const existing = this.form.names.find(n => n.langId === langId);
        if (existing) return existing;
        
        const newName = { langId, name: '' };
        this.form.names.push(newName);
        return newName;
      },
      async handleSubmit() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${this.$BASE_API_URL}/api/customizations/${this.form.id}`, {
            method: 'PUT', // or 'PATCH' depending on your API
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              ...this.form,
              defaults: this.form.defaults ? 1 : 0, // Convert boolean to 1/0
              price: parseFloat(this.form.price)
            })
          });
  
          const data = await response.json();
  
          if (!response.ok) {
            throw new Error(data.message || 'Failed to update customization');
          }
  
          this.$toast.success('Customization updated successfully!');
          this.$router.go(-1); // Return to previous page
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error(`Error: ${error.message}`);
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      cancelForm() {
        this.$router.go(-1);
      }
    }
  };
  </script>
  
  <style scoped>
  /* Reuse your existing styles */
  .form-control {
    margin-bottom: 15px;
  }
  .btn {
    padding: 8px 20px;
  }
  .btn-primary {
    background-color: #4CAF50;
    border-color: #4CAF50;
  }
  .btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
  }
  </style>